import { render, staticRenderFns } from "./QOnboardingRecruitingStatusScoreCard.vue?vue&type=template&id=4d129f60&"
import script from "./QOnboardingRecruitingStatusScoreCard.vue?vue&type=script&lang=js&"
export * from "./QOnboardingRecruitingStatusScoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports